import getEnvironmentalVariables from '../services/getEnvironmentalVariables';
import { config } from '../config';

/**
 * Extracts hostname from a URL string
 */
export const extractHostname = (url: string): string => {
    try {
        return new URL(url).hostname;
    } catch {
        return '';
    }
};

/**
 * Gets all configured app domains
 */
export const getAppDomains = (): string[] => {
    const domains: string[] = [];

    // Get deal app domain from current environment
    const envVars = getEnvironmentalVariables();
    if (envVars.BASE_URL) {
        const dealDomain = extractHostname(envVars.BASE_URL);
        if (dealDomain) domains.push(dealDomain);
    }

    // Get projects app domain from config
    if (config.northspyreProjectsAppUrl) {
        const projectsDomain = extractHostname(config.northspyreProjectsAppUrl);
        if (projectsDomain) domains.push(projectsDomain);
    }

    return domains;
};
